/* tslint:disable */
/* eslint-disable */
/**
 * LogQS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { DataStore } from "./DataStore";
import {
  DataStoreFromJSON,
  DataStoreFromJSONTyped,
  DataStoreToJSON,
} from "./DataStore";

export interface DataStoreDataResponse {
  data: DataStore;
}

export function DataStoreDataResponseFromJSON(
  json: any,
): DataStoreDataResponse {
  return DataStoreDataResponseFromJSONTyped(json);
}

export function DataStoreDataResponseFromJSONTyped(
  json: any,
): DataStoreDataResponse {
  if (json == null) {
    return json;
  }

  return {
    data: DataStoreFromJSON(json["data"]),
  };
}

export function DataStoreDataResponseToJSON(
  value: DataStoreDataResponse | null | undefined,
): any {
  if (value == null) {
    return value;
  }

  return {
    data: DataStoreToJSON(value.data),
  };
}
